"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[5149],{

/***/ 48763:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ FreemiumLimitBottomBar)
});

// EXTERNAL MODULE: ./pages/questions/components/freemium_limit_bottom_bar/index.erb
var freemium_limit_bottom_bar = __webpack_require__(25843);
// EXTERNAL MODULE: ./pages/questions/components/freemium_limit_bottom_bar/index.rb
var components_freemium_limit_bottom_bar = __webpack_require__(305);
// EXTERNAL MODULE: ./pages/questions/components/freemium_limit_bottom_bar/index.scss
var questions_components_freemium_limit_bottom_bar = __webpack_require__(20121);
// EXTERNAL MODULE: ./utils/countdown/index.js
var countdown = __webpack_require__(56392);
// EXTERNAL MODULE: ./pages/questions/components/freemium_limit_bottom_bar/index.module.scss
var index_module = __webpack_require__(28894);
// EXTERNAL MODULE: ./utils/stimulus/index.js
var stimulus = __webpack_require__(40225);
;// CONCATENATED MODULE: ./pages/questions/components/freemium_limit_bottom_bar/utils.js
const setNoScroll = ()=>{
    const isMobile = window.jQuery(window).width() < 768;
    if (isMobile) {
        window.jQuery('body').addClass('q-no-scroll');
    }
};
const removeNoScroll = ()=>{
    const hasNoScrollClass = window.jQuery('body').hasClass('q-no-scroll');
    if (hasNoScrollClass) {
        window.jQuery('body').removeClass('q-no-scroll');
    }
};

;// CONCATENATED MODULE: ./pages/questions/components/freemium_limit_bottom_bar/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







const CARD_TYPES = {
    ANSWERS: 'answers',
    LESSONS: 'lessons',
    COMMENTS: 'comments'
};
const AnalyticsCardTypes = {
    answers: 'Respostas',
    lessons: 'Cursos',
    comments: 'Comentários'
};
class FreemiumLimitBottomBar extends stimulus/* Controller */.Q {
    _sendAnalyticsEvent(eventName, data = {}) {
        UserTracker.emit('event', {
            eventName: eventName,
            data: data
        });
    }
    highlightComments() {
        const $commentsTab = window.jQuery('[data-component-name="question_comments"]');
        $commentsTab.find('.cta-pulse').removeClass('hidden');
    }
    runCountdownBottomBar(cardType) {
        (0,countdown/* default */.Z)({
            selector: `#freemium-limit-bottom-bar .card-limit-countdown-${cardType}`,
            template: '%H:%M:%S'
        });
    }
    getResourcesSummary() {
        return _async_to_generator(function*() {
            try {
                const { summary } = yield Thor.User.used_resources_summary({
                    user_id: currentUser.id
                }, {});
                const resources = summary.resources;
                return resources;
            } catch (error) {
                Rollbar.error('Error on getResourcesSummary', error);
            }
        })();
    }
    handleCollapsableButton() {
        if (this.$freemiumLimitBottomBar.hasClass('opened')) {
            this.$freemiumLimitBottomBar.removeClass('opened');
            removeNoScroll();
        } else {
            this.$freemiumLimitBottomBar.addClass('opened');
            setNoScroll();
            if (!this.sentAnalytics) {
                this._sendAnalyticsEvent('study suggestion viewed', {
                    component_study_suggestion: 'Bottombar após limite de 10 questões',
                    request_path: window.location.pathname
                });
                this.sentAnalytics = true;
            }
        }
    }
    handleExitButton() {
        this.setClosedBottomBar();
        removeNoScroll();
        this.$freemiumLimitBottomBar.addClass('hidden');
    }
    setClosedBottomBar() {
        this.$freemiumLimitBottomBar.hasClass('opened') && this.$freemiumLimitBottomBar.removeClass('opened');
    }
    anyHasLimit(resources) {
        const { answers, comments, lessons } = resources;
        const selectedResources = {
            answers,
            comments,
            lessons
        };
        return Object.values(selectedResources).some((resource)=>resource.remaining > 0);
    }
    answersLimitReached(resources) {
        return !resources.answers.remaining;
    }
    changeHtmlWithoutLimit(resources) {
        if (this.anyHasLimit(resources)) {
            return;
        }
        window.jQuery('#bottom-bar-closed-info').find('h4 span').html(', continue estudando de graça, <strong>em breve!</strong>');
        window.jQuery('.content-bar').find('#subtitle').text('Você terá acesso aos seus recursos novamente ao fim do contador, ou estude sem limites assinando nosso plano! ');
    }
    showCountdown(resources) {
        const self = this;
        window.jQuery('.card-wrapper').each(function() {
            const cardType = window.jQuery(this).data('card-type');
            const limitReached = resources[cardType].remaining === 0;
            if (!limitReached) {
                return;
            }
            window.jQuery(this).addClass(`${index_module["default"]["limit-reached"]}`);
            window.jQuery(this).find(`.${index_module["default"]["card-countdown"]}`).toggleClass('hidden', !limitReached);
            self.runCountdownBottomBar(cardType);
        });
    }
    OpenBottomBarEventScroll() {
        const self = this;
        const firstScrollDone = false;
        window.addEventListener('scroll', function() {
            if (firstScrollDone || self.$freemiumLimitBottomBar.hasClass('hidden')) {
                return;
            }
            self.handleCollapsableButton();
            this.firstScrollDone = true;
        }, {
            once: true
        });
    }
    handleCardClick(event) {
        event.preventDefault();
        const cardType = window.jQuery(event.currentTarget).data('card-type');
        const limitReached = window.jQuery(event.currentTarget).hasClass(`${index_module["default"]["limit-reached"]}`);
        if (cardType === CARD_TYPES.ANSWERS || limitReached) {
            return;
        }
        this._sendAnalyticsEvent('study suggestion interest', {
            component_study_suggestion: 'Bottombar após limite de 10 questões',
            selected_study_suggestion: AnalyticsCardTypes[cardType],
            request_path: window.location.pathname
        });
        if (cardType === CARD_TYPES.LESSONS) {
            window.location.href = window.jQuery(event.currentTarget).data('redirect-url');
        } else if (cardType === CARD_TYPES.COMMENTS) {
            this.highlightComments();
            this.handleCollapsableButton();
        } else {
            this.handleCollapsableButton();
        }
    }
    load() {
        var _this = this;
        return _async_to_generator(function*() {
            const resources = yield _this.getResourcesSummary();
            const answersLimitReached = _this.answersLimitReached(resources);
            if (!answersLimitReached) {
                return;
            }
            _this.setClosedBottomBar();
            _this.showCountdown(resources);
            _this.changeHtmlWithoutLimit(resources);
            _this.$freemiumLimitBottomBar.removeClass('hidden');
        })();
    }
    constructor(){
        super();
        this.sentAnalytics = false;
        this.$freemiumLimitBottomBar = window.jQuery('#freemium-limit-bottom-bar');
        this.$collapsedContainerButtons = window.jQuery('.js-collapsed-container-buttons', this.$freemiumLimitBottomBar);
        this.$uncollapsedContainerButtons = window.jQuery('.js-uncollapsed-container-buttons', this.$freemiumLimitBottomBar);
    }
}

(self || window).FreemiumLimitBottomBarApplication = (self || window).FreemiumLimitBottomBarApplication || stimulus/* Application.start */.M.start();
(self || window).FreemiumLimitBottomBarApplication.register('freemium-limit-bottom-bar-events', FreemiumLimitBottomBar);


/***/ }),

/***/ 32400:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _components_resource_limit_counter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86274);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30084);
/* harmony import */ var components_alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84880);
/* harmony import */ var components_freemium_trainer_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54764);
/* harmony import */ var components_modals_account_limit_questions_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24363);
/* harmony import */ var utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62346);
/* harmony import */ var utils_cookie_manager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88526);
/* harmony import */ var components_modals_forum_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77322);
/* harmony import */ var _components_freemium_limit_bottom_bar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48763);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87322);
/* harmony import */ var _onboarding_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57671);
/* harmony import */ var components_modals_planner_modal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57912);
/* harmony import */ var components_modals_questions_review_suggestion_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32045);
/* harmony import */ var utils_study_study__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21189);
/* harmony import */ var components_modals_weekly_activity_modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56782);
/* harmony import */ var components_modals_continue_modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47413);
/* harmony import */ var utils_permissions_feedbacks__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49024);
/* harmony import */ var utils_permissions_rules__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66593);
/* harmony import */ var utils_event_manager__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69705);
/* harmony import */ var utils_api_error_handler__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(98973);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




















class Question {
    getAlternative() {
        return window.jQuery('.js-question-answer:checked', this.$question);
    }
    isResolved() {
        return this.$question.hasClass('q-question-is-correct');
    }
    isMultipleChoice() {
        return this.$question.hasClass('js-question-is-multiple-choice');
    }
    getCorrectAnswer(resolve) {
        if (this.isMultipleChoice()) {
            return resolve.right_answer;
        }
        return resolve.right_answer === 'C' ? 'Certo' : 'Errado';
    }
    answer() {
        var _this = this;
        return _async_to_generator(function*() {
            var _gon_flags_ansewered_correctly_won_extra_questions;
            if (!utils_permissions_rules__WEBPACK_IMPORTED_MODULE_17__/* ["default"].account */ .Z.account() || !utils_permissions_rules__WEBPACK_IMPORTED_MODULE_17__/* ["default"].confirmed_account */ .Z.confirmed_account()) {
                return;
            }
            _this.$answerBtn.attr('disabled', true).attr('aria-disabled', true);
            const $alternative = _this.getAlternative();
            const answer = $alternative.val();
            yield _this.resolveQuestion(answer);
            const data = {
                resolvedQuestions: _this.resolvedTodayCounter,
                question_id: _this.questionId
            };
            const chalangeQuestionAllowed = utils_cookie_manager__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getCookie */ .Z.getCookie('question_challange_phase') !== 'false';
            const onboardingModalFlagOn = (_gon_flags_ansewered_correctly_won_extra_questions = gon.flags.ansewered_correctly_won_extra_questions) == null ? void 0 : _gon_flags_ansewered_correctly_won_extra_questions.visible;
            if (_this.resolvedTodayCounter === 9 && chalangeQuestionAllowed && onboardingModalFlagOn) {
                _this.handleQuestionChallenge();
            }
            utils_event_manager__WEBPACK_IMPORTED_MODULE_18__/* .EventManager.publish */ .Q.publish('question.answer', data);
            utils_study_study__WEBPACK_IMPORTED_MODULE_13__/* ["default"].trackWithoutCheckLimits */ .Z.trackWithoutCheckLimits('answers');
        })();
    }
    resolveQuestion(answer) {
        var _this = this;
        return _async_to_generator(function*() {
            yield Thor.Question.resolve({
                id: _this.questionId
            }, {
                data: {
                    answer: answer,
                    search_id: gon.questions_search_id
                }
            }).then((data)=>{
                var _gon_flags_banner_count_questions;
                _this.resolvedTodayCounter = data.used_answers;
                _this.handleAnswerSuccess(answer, data);
                _this.handleCheckin(data.checkin);
                _this.handleFirstQuestionEvent(data.used_answers);
                if ((_gon_flags_banner_count_questions = gon.flags.banner_count_questions) == null ? void 0 : _gon_flags_banner_count_questions.visible) {
                    _this.handleQuestionCounter(data.used_answers);
                }
            }).catch((err)=>{
                Rollbar.error('Error on integration with thor', {
                    user: currentUser,
                    error: err
                });
                _this.handleAnswerError(err);
            });
        })();
    }
    handleFirstQuestionEvent(usedAnswers) {
        const isFirstQuestionToday = usedAnswers === 1;
        if (!isFirstQuestionToday) {
            return;
        }
        if (window.notifyExperimentBenefits) {
            window.notifyExperimentBenefits();
        }
    }
    handleQuestionCounter(usedAnswers) {
        const $counter = this.$question.find('.resource-limit-counter');
        if (!$counter) {
            return;
        }
        const answersThreshold = this.$question.data('threshold');
        if (answersThreshold > 20) {
            return;
        }
        const remaining = answersThreshold - usedAnswers;
        const percentage = 100 * usedAnswers / answersThreshold;
        let title = `Restam ${remaining} questões gratuitas para resolver hoje!`;
        if (remaining === 1) {
            title = 'Resta 1 questão gratuita para resolver hoje!';
        }
        if (remaining === 0) {
            title = 'Esta foi sua última questão gratuita resolvida hoje';
        }
        $counter.find('.resource-limit-title').html(title);
        $counter.find('.resource-limit-counter-progress').attr('style', `--value:${percentage}`);
        $counter.removeClass('hidden');
    }
    handleCheckin(data) {
        const { active, active_weeks_count } = data;
        const isCheckinAnswer = active;
        this.checkinContent = this.$question.data('checkin-content');
        const checkinModalEnabled = isCheckinAnswer && active_weeks_count < 6;
        const isPageAllowed = !(this.checkinContent.index_only && this.isQuestionShowPath);
        if (checkinModalEnabled && isPageAllowed) {
            utils_event_manager__WEBPACK_IMPORTED_MODULE_18__/* .EventManager.publish */ .Q.publish('checkinModal.open');
            this.loadWeeklyActivityModal(active_weeks_count);
        }
    }
    loadWeeklyActivityModal(weekNumber) {
        var _this = this;
        return _async_to_generator(function*() {
            yield utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"].load */ .Z.load({
                component: 'modals/weekly_activity_modal',
                type: 'component',
                data: {
                    week_number: weekNumber,
                    modal_content: _this.checkinContent
                }
            }).then((html)=>{
                window.jQuery('body').append(html);
                new components_modals_weekly_activity_modal__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z();
            });
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_9__/* ["default"].open */ .Z.open('#js-questions-weekly-activity-modal');
        })();
    }
    handleAnswerSuccess(answer, data) {
        const status = data.resolve.status;
        const correctAnswer = this.getCorrectAnswer(data.resolve);
        status === 'correct' ? this.handleCorrectAnswer() : this.handleWrongAnswer(answer, correctAnswer);
        if (this.resolvedTodayCounter === 4 && this.isAnswerTipAllowed) {
            this.showQuestionTip();
        }
        this.$question.parents('.js-question-item').data('status', 'resolved');
        this.$question.attr('data-answer', answer);
        this.$question.attr('data-correct-answer', correctAnswer);
        this.$banner && this.$banner.addClass('q-page-content-banner-opened');
        this.handlePlannerModal();
    }
    handleCorrectAnswer() {
        this.resetDiscipline();
        this.$question.removeClass('q-question-is-wrong');
        this.$question.addClass('q-question-is-correct');
        this.pulseStudentsComments('correct');
    }
    handleWrongAnswer(answer, correctAnswer) {
        if (this.postAllowed()) {
            this.$forumBtn.removeClass('hidden');
            this.$forumBtn.data('answer', answer);
        }
        this.pulseStudentsComments('wrong');
        if (this.isModalContinueAllowed()) {
            this.handleWrongStreak();
        }
        this.$question.addClass('q-question-is-wrong');
        this.$question.removeClass('q-question-is-correct');
        this.$question.find('.js-question-right-answer').text(correctAnswer).attr('aria-label', correctAnswer);
        this.handleExperimentTooltipQuestionBelt();
    }
    handleExperimentTooltipQuestionBelt() {
        const cookieName = `wrongAnswerTooltipViewed.${currentUser.id}`;
        const $questionBelt = window.jQuery(`.q-question-belt[data-question-id="${this.questionId}"]`);
        const showTooltip = $questionBelt.data('wrong-answer-tooltip');
        const tooltipAlreadyViewed = utils_cookie_manager__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getCookie */ .Z.getCookie(cookieName) !== null;
        if (!showTooltip || tooltipAlreadyViewed) {
            return;
        }
        const componentName = $questionBelt.data('wrong-answer-tooltip-priority');
        const $tooltip = $questionBelt.find(`[data-component-name="${componentName}"] [data-toggle="tooltip"]`);
        const oldTooltipMessage = $tooltip.attr('title') || $tooltip.attr('data-original-title');
        const newTooltipMessage = $tooltip.attr('wrong-answer-tooltip');
        // Change tooltip message and show tooltip
        $tooltip.attr('title', newTooltipMessage);
        $tooltip.attr('data-original-title', newTooltipMessage);
        $tooltip.addClass('wrong-answer-tooltip');
        $tooltip.tooltip().mouseover();
        // Restore tooltip message
        $tooltip.on('mouseleave', ()=>{
            $tooltip.attr('title', oldTooltipMessage);
            $tooltip.attr('data-original-title', oldTooltipMessage);
            $tooltip.removeClass('wrong-answer-tooltip');
        });
        // Set wrongAnswerTooltipViewed cookie
        const currentDate = new Date();
        const expirationDate = new Date(currentDate);
        expirationDate.setHours(0, 0, 0, 0);
        expirationDate.setDate(currentDate.getDate() + 1);
        utils_cookie_manager__WEBPACK_IMPORTED_MODULE_6__/* ["default"]._setCookie */ .Z._setCookie(cookieName, true, expirationDate);
    }
    handleAnswerError(err) {
        const response = err.response;
        const hasJsonError = response && response.json;
        const apiErrorMessage = 'Ops! Não foi possível resolver a questão nesse momento!';
        hasJsonError ? this.handleLimitRached(response) : (0,utils_api_error_handler__WEBPACK_IMPORTED_MODULE_19__/* .handleApiError */ .z)(apiErrorMessage, err);
    }
    handleLimitRached(response) {
        response.json().then((data)=>{
            var _data_errors;
            if ((_data_errors = data.errors) == null ? void 0 : _data_errors.limit_reached) {
                if (this.newQuestionLimitModalIsActive) {
                    utils_permissions_feedbacks__WEBPACK_IMPORTED_MODULE_16__/* ["default"].newQuestionLimitModal */ .Z.newQuestionLimitModal();
                } else if (this.questionBeltLimitBlockExperimentIsActive) {
                    utils_permissions_feedbacks__WEBPACK_IMPORTED_MODULE_16__/* ["default"].questionBeltBlock */ .Z.questionBeltBlock();
                } else {
                    utils_permissions_feedbacks__WEBPACK_IMPORTED_MODULE_16__/* ["default"].resolveQuestionLimit */ .Z.resolveQuestionLimit();
                }
                if (this.isDailyReviewAllowed()) {
                    this.setQuestionsReviewSuggestionListener();
                }
                const $container = window.jQuery('.js-onboarding-container');
                if ($container.length) {
                    $container.hide();
                    utils_cookie_manager__WEBPACK_IMPORTED_MODULE_6__/* ["default"].setExpirationCookie */ .Z.setExpirationCookie(this.cookieName, false, 1);
                }
                if (this.bottomBarStudySuggestion) {
                    const freemiumLimitBottomBar = new _components_freemium_limit_bottom_bar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z();
                    freemiumLimitBottomBar.load();
                    freemiumLimitBottomBar.OpenBottomBarEventScroll();
                }
                this.blockQuestionBeltToUnansweredQuestion();
            }
        });
    }
    handleQuestionChallenge() {
        const answeredQuestions = utils_cookie_manager__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getCookie */ .Z.getCookie('question_challange_answered') || [
            'Q0'
        ];
        const parsedAnsweredQuestions = JSON.stringify(answeredQuestions);
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"].load */ .Z.load({
            component: 'questions/onboarding_modal',
            type: 'page_component',
            data: {
                questions_answered_keys: parsedAnsweredQuestions
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            new _onboarding_modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z();
        });
    }
    blockQuestionBeltToUnansweredQuestion() {
        const experimentQuestionBeltBlockIsActive = gon.flags.question_belt_block.visible;
        const experimentQuestionBeltLimitsIsActive = gon.flags.question_belt_limits.visible;
        const commentsTabQuestionBelt = window.jQuery('.js-question-item a[data-component-name="question_comments"]');
        const commentedFeedbackQuestionBelt = window.jQuery('.js-question-item a[data-component-name="question_teacher"]');
        const statisticsQuestionBelt = window.jQuery('.js-question-item a[data-component-name="question_statistics"]');
        let questionBeltItemsThatWillBeDisabled = [
            ...commentsTabQuestionBelt
        ];
        if (this.questionBeltLimitBlockExperimentIsActive) {
            questionBeltItemsThatWillBeDisabled = [
                ...commentsTabQuestionBelt,
                ...commentedFeedbackQuestionBelt,
                ...statisticsQuestionBelt
            ];
        }
        if (experimentQuestionBeltLimitsIsActive) {
            return;
        }
        questionBeltItemsThatWillBeDisabled.forEach((element)=>{
            const $belt = window.jQuery(element);
            $belt.data('limited', true);
            if (experimentQuestionBeltBlockIsActive) {
                $belt.data('disabled', true);
            } else {
                const atUnsolvedQuestion = $belt.parents('.js-question-item').data('status') === 'unsolved';
                if (atUnsolvedQuestion) {
                    $belt.data('disabled', true);
                }
            }
        });
    }
    handlePlannerModal() {
        const { planner_modal_enabled } = gon;
        const isPlannerModalDisabled = localStorage.getItem('plannerModalDisabled') === 'true';
        const resolvedEnoughQuestions = this.resolvedTodayCounter === 4;
        if (!planner_modal_enabled || isPlannerModalDisabled || !resolvedEnoughQuestions) {
            return;
        }
        this.loadPlannerModal();
    }
    showQuestionTip() {
        const hasCommentaries = this.$question.data('comments-count');
        const hitAnswer = this.$question.hasClass('q-question-is-correct');
        const missInfoContainer = window.jQuery('.js-response-wrong', this.$question);
        const hitInfoContainer = window.jQuery('.js-response-correct', this.$question);
        if (hitAnswer) {
            return hitInfoContainer.addClass('q-show-tip-info');
        }
        const wrongAnswerFeedbackText = window.jQuery('.q-answer-feedback', missInfoContainer);
        if (hasCommentaries) {
            wrongAnswerFeedbackText.css('width', '215px');
            missInfoContainer.addClass('q-show-tip-info');
        }
    }
    pulse() {
        this.$studentsCommentsPulse.classList.toggle('hidden');
    }
    pulseStudentsComments(answer_status) {
        if (this.$studentsCommentsPulse) {
            const handleAnswer = this.$studentsCommentsPulse.dataset[answer_status] === 'true';
            if (handleAnswer) {
                this.pulse();
            }
        }
    }
    openQuestionsReviewSuggestionModal(self) {
        window.jQuery('#js-account-limit-free-modal').off('hidden.bs.modal');
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"].load */ .Z.load({
            component: 'modals/questions_review_suggestion_modal',
            type: 'component',
            data: {
                product_slug: self.productSlug
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            new components_modals_questions_review_suggestion_modal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z();
        });
    }
    isDailyReviewAllowed() {
        return gon.review_suggestion_modal_enabled;
    }
    setQuestionsReviewSuggestionListener() {
        let self = this;
        window.jQuery('#js-account-limit-free-modal').on('hidden.bs.modal', ()=>self.openQuestionsReviewSuggestionModal(self));
    }
    postAllowed() {
        return this.isForumAllowed() && this.isForumPostAllowed() && this.productSlug === 'questoes-de-concursos';
    }
    isForumAllowed() {
        return window.FLAGS.forum;
    }
    isForumPostAllowed() {
        return window.FLAGS.odin_forum_post;
    }
    loadForumModal() {
        window.jQuery('#js-forum-modal').remove();
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"].load */ .Z.load({
            component: 'modals/forum_modal',
            type: 'component',
            data: {
                question_id: this.questionId,
                question_answer: this.$forumBtn.data('answer')
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            new components_modals_forum_modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z('#js-forum-modal');
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_9__/* ["default"].open */ .Z.open('#js-forum-modal');
        });
    }
    isModalContinueAllowed() {
        const allowed = window.FLAGS.modal_statistics;
        const hidden = !localStorage || localStorage.getItem('continueModalHide');
        return allowed && !hidden;
    }
    loadContinueModal() {
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"].load */ .Z.load({
            component: 'modals/continue_modal',
            type: 'component',
            data: {
                discipline_id: this.disciplineId,
                product_slug: this.productSlug
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            (0,components_modals_continue_modal__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_9__/* ["default"].open */ .Z.open('#js-continue-modal');
        });
    }
    loadPlannerModal() {
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"].load */ .Z.load({
            component: 'modals/planner_modal',
            type: 'component',
            data: {
                questions_filter: this.questionParams
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_9__/* ["default"].open */ .Z.open('#js-planner-modal');
            new components_modals_planner_modal__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z();
        }).catch((err)=>{
            throw new Error(err);
        });
    }
    disciplineStorageKey() {
        return `missedStreakDiscipline:${this.disciplineId}`;
    }
    wrongStreakCounter() {
        return parseInt(localStorage.getItem(this.disciplineStorageKey())) || 0;
    }
    wrongStreakIncrement() {
        localStorage.setItem(this.disciplineStorageKey(), this.wrongStreakCounter() + 1);
    }
    resetDiscipline() {
        localStorage.removeItem(this.disciplineStorageKey());
    }
    handleWrongStreak() {
        this.wrongStreakIncrement();
        if (this.wrongStreakCounter() >= this.limitWrongStreak) {
            this.loadContinueModal();
            this.resetDiscipline();
        }
    }
    validate() {
        const $alternative = this.getAlternative();
        if ($alternative.length && !this.isResolved()) {
            this.$answerBtn.attr('disabled', false).attr('aria-disabled', false);
        } else {
            this.$answerBtn.attr('disabled', true).attr('aria-disabled', true);
        }
    }
    discardAlternative() {
        const $discarders = window.jQuery('.js-discard-alternative', this.$question);
        $discarders.on('click.discardsAlternative', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const $discarder = window.jQuery(e.currentTarget);
            $discarder.toggleClass('q-discard-alternative--discarded');
            $discarder.siblings('.js-alternative-content').toggleClass('discarded');
            $discarder.siblings('.js-question-answer').prop('checked', false);
            this.validate();
        });
    }
    recoverAlternative() {
        const $alternatives = window.jQuery('.js-question-answer', this.$question);
        $alternatives.on('change.chooseAlternative', (e)=>{
            const $alternative = window.jQuery(e.currentTarget);
            $alternative.siblings('.js-alternative-content').removeClass('discarded');
            $alternative.siblings('.js-discard-alternative').removeClass('q-discard-alternative--discarded');
        });
    }
    setFeedbackRedesign() {
        const answerFeedbacks = window.jQuery('.q-inline-answer', this.$question);
        this.isFeedbackRedesignAllowed && answerFeedbacks.addClass('feedback-redesign');
    }
    bind() {
        this.$answerBtn.on('click.answer', ()=>this.answer());
        window.jQuery('.js-question-answer', this.$question).on('change.answer', ()=>this.validate());
        this.$forumBtn.on('click', ()=>this.loadForumModal());
        this.setFeedbackRedesign();
        this.discardAlternative();
        this.recoverAlternative();
    }
    constructor($question){
        var _gon_flags_modal_limitation, _gon_flags_study_sugestion;
        this.$question = $question;
        this.$answerBtn = window.jQuery('.js-answer-btn', this.$question);
        this.$banner = window.jQuery('.q-page-content-banner');
        this.$forumBtn = window.jQuery('.js-forum-btn', this.$question);
        this.questionId = $question.data('questionId');
        this.isQuestionShowPath = $question.data('question-show-path');
        this.questionParams = $question.data('questionParams');
        this.disciplineId = $question.data('disciplineId');
        this.productSlug = $question.data('productSlug');
        this.limitWrongStreak = 8;
        this.$studentsCommentsPulse = document.querySelector(`.js-${this.questionId}-has-comments`);
        this.isFeedbackRedesignAllowed = $question.data('feedback-redesign');
        this.isAnswerTipAllowed = $question.data('show-feedback-tip');
        this.questionBeltLimitBlockExperimentIsActive = gon.flags.question_belt_block.visible;
        this.newQuestionLimitModalIsActive = (_gon_flags_modal_limitation = gon.flags.modal_limitation) == null ? void 0 : _gon_flags_modal_limitation.active;
        this.bottomBarStudySuggestion = (_gon_flags_study_sugestion = gon.flags.study_sugestion) == null ? void 0 : _gon_flags_study_sugestion.active;
        this.bind();
    }
}
(function($1) {
    'use strict';
    $1('.js-question').each((i, el)=>{
        el.question = new Question($1(el));
    });
})(window.jQuery);


/***/ })

}]);